module.exports = __webpack_public_path__ + "static/mieszkania-puck-rynek-pierwotny-tablet-d0caa08b255c96a5ef3a5476fdb66d4f.jpg";